export const baseUrl = 'https://toomar.co';
export const BASE_URL = 'https://toomar.co/api/';
